<template>
  <sc-page-base
    title="Performance de Entregas"
    :loading="loading">

    <sc-grid
      :name="$options.name"
      :data="reportData.entries"
      :total="reportData.total"
      :default-filters="defaultFilters"
      default-sort-column="id"
      default-sort-direction="ascending"
      @submit="config"
      @pagination="config"
      @sorting="config">

      <template slot="filters" slot-scope="{ filters }">
        <sc-report-performance-filters :filters="filters" />
      </template>

      <template
        slot="after-filters"
        v-if="reportData.total">
        <div class="box">
          <sc-report-performance-chart />
        </div>
      </template>

      <template
        slot="before-table"
        v-if="reportData.total">
        <div class="buttons">
          <sc-button
            theme="primary"
            :loading="exportLoading"
            text="Exportar para o Excel"
            icon="file-excel"
            @click="exportReport(reportConfig)"/>
        </div>
      </template>

      <template slot="table-columns" slot-scope="{ props }">
        <sc-table-column
          field="order_number"
          label="Número do Pedido"
          sortable>
          {{ props.row.order_number }}
        </sc-table-column>

        <sc-table-column
          field="invoices"
          label="Número da Nota"
          sortable>
          {{ listInvoiceNumbers(props.row.invoices) }}
        </sc-table-column>

        <sc-table-column
          field="shipping_first_name"
          :centered="false"
          label="Nome do Cliente"
          sortable>
          {{ getFullName(props.row.shipping_first_name, props.row.shipping_last_name) }}
        </sc-table-column>

        <sc-table-column
          field="logistic_provider_name"
          :centered="false"
          label="Provedor Logístico"
          sortable>
          {{ props.row.logistic_provider_name }}
        </sc-table-column>

        <sc-table-column
          :centered="false"
          field="delivery_method_name"
          label="Método de Entrega"
          sortable>
          {{ props.row.delivery_method_name }}
        </sc-table-column>

        <sc-table-column
          field="estimated_delivery_date_iso"
          label="Data de Entrega Estimada Cliente"
          sortable>
          {{ props.row.estimated_delivery_date_iso | date('DD/MM/YYYY') }}
        </sc-table-column>

        <sc-table-column
          field="estimated_delivery_date_lp_iso"
          label="Data de Entrega Estimada Transp."
          sortable>
          {{ props.row.estimated_delivery_date_lp_iso | date('DD/MM/YYYY') }}
        </sc-table-column>

        <sc-table-column
          field="delivered_date_iso"
          label="Data de entrega"
          sortable>
          {{ props.row.delivered_date_iso | date('DD/MM/YYYY') }}
        </sc-table-column>

        <sc-table-column
          :centered="false"
          field="on_time_localized"
          label="Performance Cliente"
          sortable>
          {{ props.row.on_time_localized }}
        </sc-table-column>

        <sc-table-column
          :centered="false"
          field="on_time_lp_localized"
          label="Performance Transp."
          sortable>
          {{ props.row.on_time_lp_localized }}
        </sc-table-column>

        <sc-table-column
          field="shipping_state"
          label="Estado"
          sortable>
          {{ props.row.shipping_state }}
        </sc-table-column>

        <sc-table-column
          field="created_at_date_time_iso"
          label="Criado em"
          sortable>
          {{ props.row.created_at_date_time_iso | date('DD/MM/YYYY') }}
        </sc-table-column>
      </template>

    </sc-grid>

  </sc-page-base>
</template>

<script>
  import { Moment } from '@intelipost-js/secure-providers';
  import { ScPageBase, ScGrid, ScIcon, ScButton, ScTableColumn } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  import ScReportPerformanceFilters from './components/sc-report-performance-filters/ScReportPerformanceFilters';
  import ScReportPerformanceChart from './components/sc-report-performance-chart/ScReportPerformanceChart';

  const { mapState, mapActions } = createNamespacedHelpers('analytic/performance');

  export default {
    name: 'page-report-performance',
    data() {
      return {
        reportConfig: {},
        defaultFilters: {
          occurrence: null,
          vision: 'user',
          region: null,
          period: 'CREATED_DATE',
          dateRange: {
            start: Moment().subtract(1, 'days').format('YYYY-MM-DD'),
            end: Moment().format('YYYY-MM-DD'),
          },
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'exportLoading',
        'reportData',
      ]),
    },
    methods: {
      ...mapActions([
        'generateReport',
        'exportReport',
      ]),
      config(config) {
        this.reportConfig = config;
        this.generateReport(config);
      },
      getFullName(firstName, lastName) {
        return `${firstName || ''} ${lastName || ''}`;
      },
      listInvoiceNumbers(invoices) {
        return invoices
          .filter(invoice => invoice.invoice_number && invoice.invoice_series)
          .map(invoice => `${invoice.invoice_number}-${invoice.invoice_series}`)
          .join(', ');
      },
    },
    components: {
      ScPageBase,
      ScGrid,
      ScIcon,
      ScButton,
      ScTableColumn,
      ScReportPerformanceFilters,
      ScReportPerformanceChart,
    },
  };
</script>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/performance/PageReportPerformance.vue